import { c as _c } from "react/compiler-runtime";
import { DropdownMenu } from '@common/components';
import { cn } from '@core/utils';
import { useState } from 'react';
import { UnauthQueryKey } from '@/api';
import type { GiftProductListItem } from '@/api/getGiftProductList';
import { getGiftProductList } from '@/api/getGiftProductList';
import { GiftCard } from '@/app/_components/GiftCard/GiftCard';
import { InfiniteListWithMoreButton } from '@/app/donation/_components/InfiniteListWithMoreButton';
import { GIFT_SALE_STATUS } from '@/app/donation/constants';
import type { WEBVIEW_TYPE_ENTRY } from '@/constants/entry';
import { useOverlayHistory } from '@/hooks/useOverlayHistory';
import { GTM_EVENT_TYPE, trackGtmEvent } from '@/utils/analytics/gtm';
import { DEFAULT_GIFT_PRODUCT_SORT, GIFT_PRODUCT_PAGE_SIZE } from '../../constants';
import { InfiniteListMoreButton } from '../InfiniteListMoreButton';
import { SORT_OPTIONS } from './constants';
import type { SortValue } from './types';

//* 굿즈증정 뱃지는 지역 마감에 따라 바뀐다 — 전역 기본(5분) 대신 1분만 재사용한다
const GIFT_LIST_STALE_TIME = 60_000;
interface GiftsContentProps {
  institutionId: number;
  initialData?: GiftProductListItem[];
  totalCount: number;
  entry: WEBVIEW_TYPE_ENTRY;
}
export const GiftsContent = t0 => {
  const $ = _c(25);
  const {
    institutionId,
    initialData,
    totalCount,
    entry
  } = t0;
  const [selectedSort, setSelectedSort] = useState(DEFAULT_GIFT_PRODUCT_SORT);
  const [isSortMenuOpened, setIsSortMenuOpened] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsSortMenuOpened(false);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useOverlayHistory(isSortMenuOpened, t1);
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("mt-64 font-700 text-Gray-900 typo-body2", "mobile-tablet:mt-20");
    t3 = cn("mb-12 flex items-center justify-between", "mobile-sm:hidden");
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== totalCount) {
    t4 = <div className="font-500 text-Gray-black typo-body4"><span>전체 {totalCount}개</span></div>;
    $[3] = totalCount;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== isSortMenuOpened || $[6] !== selectedSort) {
    t5 = <DropdownMenu type="text" value={selectedSort} options={SORT_OPTIONS} open={isSortMenuOpened} onOpenChange={setIsSortMenuOpened} onChange={setSelectedSort} align="end" contentClassName="!min-w-160" />;
    $[5] = isSortMenuOpened;
    $[6] = selectedSort;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <div className={t3}>{t4}{t5}</div>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = cn("grid gap-x-12 gap-y-32", "grid-cols-2 tablet:grid-cols-4 xl:grid-cols-4", "mobile-sm:grid-cols-1 mobile-sm:gap-y-24");
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <InfiniteListMoreButton />;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t10;
  let t9;
  if ($[13] !== entry || $[14] !== institutionId || $[15] !== selectedSort) {
    t9 = [...UnauthQueryKey["get:/wello/v2/allows/home/gift-product"](), selectedSort, institutionId, entry];
    t10 = t11 => {
      const {
        pageParam
      } = t11;
      return getGiftProductList({
        giftProductSortType: selectedSort,
        institutionId,
        size: GIFT_PRODUCT_PAGE_SIZE,
        page: pageParam,
        entry
      }).then(_temp);
    };
    $[13] = entry;
    $[14] = institutionId;
    $[15] = selectedSort;
    $[16] = t10;
    $[17] = t9;
  } else {
    t10 = $[16];
    t9 = $[17];
  }
  let t11;
  if ($[18] !== initialData || $[19] !== t10 || $[20] !== t9) {
    t11 = <div className={t7}><InfiniteListWithMoreButton initialData={initialData} moreButtonComponent={t8} queryKey={t9} queryFn={t10} pageSize={GIFT_PRODUCT_PAGE_SIZE} staleTime={GIFT_LIST_STALE_TIME} renderItem={_temp2} getItemKey={_temp3} /></div>;
    $[18] = initialData;
    $[19] = t10;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t6) {
    t12 = <div className={t2}>{t6}{t11}</div>;
    $[22] = t11;
    $[23] = t6;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  return t12;
};
function _temp(context) {
  return context?.contents ?? [];
}
function _temp2(item, index) {
  return <GiftCard mainImageUrl={item.mainImageUrl} productName={item.productName} isSoldOut={item.productSaleStatus === GIFT_SALE_STATUS.SOLD_OUT} hasEditionBadge={item.editionBadge} donationAmount={item.requiredDonationAmount} reviewRating={item.reviewRating} reviewCount={item.reviewCount} showRating={item.reviewCount > 0} productNumber={item.productSlugId ?? item.productNumber} onGiftLinkClick={() => {
    trackGtmEvent(GTM_EVENT_TYPE.SELECT_ITEM, {
      currency: "KRW",
      value: item.requiredDonationAmount,
      local_name: item.institutionName,
      items: [{
        item_type: "\uB2F5\uB840\uD488",
        item_list_name: "\uC9C0\uC790\uCCB4 \uC0C1\uC138 \uB2F5\uB840\uD488 \uD0ED",
        item_list_id: item.productNumber,
        price: item.requiredDonationAmount,
        item_name: item.productName,
        quantity: 1,
        item_id: item.productNumber
      }]
    });
  }} isAdult={item.adultYN} isNew={item.newDisplayYN} priority={index < 4} mobileLayout="row" />;
}
function _temp3(item_0) {
  return item_0.productNumber;
}